/**
 * 告警相关字典
 */

// 设备类型字典
export const deviceTypeDict = {
  '00': '默认',
  '01': 'PCS',
  '02': 'BCS',
  '03': 'BMS',
  '04': 'eLink',
  '05': '水机',
  '06': '消防',
  '07': '100C-dcdc',
  '08': '100C-MPPT',
  'E1': 'eBlock',
  'E2': 'EMS'
}

// 设备类型选项（用于下拉框）
export const deviceTypeOptions = [
  { title: '全部', value: '' },
  ...Object.entries(deviceTypeDict).map(([value, title]) => ({
    title,
    value
  }))
]

// 故障等级字典
export const alarmLevelDict = {
  0: '提示',
  1: '告警',
  2: '故障',
  3: '严重'
}

// 故障等级选项（用于下拉框）
export const alarmLevelOptions = [
  { title: '全部', value: '' },
  ...Object.entries(alarmLevelDict).map(([value, title]) => ({
    title,
    value: Number(value)
  }))
]

// 告警状态字典
export const alarmStateDict = {
  1: '未处理',
  2: '自动恢复',
  3: '人工确认',
  4: '已转工单',
  5: '工单处理完成'
}

// 告警状态选项（用于下拉框）
export const alarmStateOptions = [
  { title: '全部', value: '' },
  ...Object.entries(alarmStateDict).map(([value, title]) => ({
    title,
    value: Number(value)
  }))
]

// 根据值获取设备类型文本
export function getDeviceTypeText(type) {
  return deviceTypeDict[type] || type
}

// 根据值获取故障等级文本
export function getAlarmLevelText(level) {
  // 支持数字和字符串类型
  const levelValue = typeof level === 'string' ? Number(level) : level
  return alarmLevelDict[levelValue] || level
}

// 根据值获取告警状态文本
export function getAlarmStateText(state) {
  // 支持数字和字符串类型
  const stateValue = typeof state === 'string' ? Number(state) : state
  return alarmStateDict[stateValue] || state
}





